export const getProfileImageUrl = (filePath) => {
  if (!filePath || String(filePath).trim() === "") return "";
  if (/^https?:\/\//i.test(filePath)) return filePath;

  const apiBaseUrl = process.env.REACT_APP_API_URL;
  if (!apiBaseUrl) return filePath;

  return new URL(filePath, apiBaseUrl).href;
};

export const appendJsonSection = (formData, key, obj) => {
  if (obj && Object.keys(obj).length > 0) {
    formData.append(key, JSON.stringify(obj));
  }
};

export const buildBasicInfoPayload = ({
  name,
  username,
  location,
  description,
}) => ({
  name,
  username,
  location,
  description,
});

export const buildContactsFromMyProfile = (basicInformation) => {
  const contacts = [];

  if (basicInformation.contactNumber_1 || basicInformation.emailId_1) {
    contacts.push({
      contactNumber: basicInformation.contactNumber_1 || "",
      email: basicInformation.emailId_1 || "",
      isPrimary:
        basicInformation.primaryContactNumber ===
        basicInformation.contactNumber_1,
    });
  }

  if (basicInformation.contactNumber_2 || basicInformation.emailId_2) {
    contacts.push({
      contactNumber: basicInformation.contactNumber_2 || "",
      email: basicInformation.emailId_2 || "",
      isPrimary:
        basicInformation.primaryContactNumber ===
        basicInformation.contactNumber_2,
    });
  }

  if (contacts.length > 0 && !contacts.some((c) => c.isPrimary)) {
    contacts[0].isPrimary = true;
  }

  return contacts;
};

export const buildOrganizationPayload = (
  organizationDetails,
  uploadDocuments = null,
) => {
  const payload = {
    name: organizationDetails.organizationName,
    natureOfBusiness: organizationDetails.natureOfBusiness,
    website: organizationDetails.organizationContactDetails?.website || "",
    address: {
      pinCode: organizationDetails.AddressDetails.Pincode || "",
      city: organizationDetails.AddressDetails.city || "",
      state: organizationDetails.AddressDetails.state || "",
      country: organizationDetails.AddressDetails.Country || "",
    },
  };

  if (uploadDocuments) {
    const regMap = { CIN: "cin", VAT: "vat", PAN: "pan", DUNS: "duns" };
    Object.entries(regMap).forEach(([uiKey, apiKey]) => {
      const number = uploadDocuments[uiKey]?.number;
      if (number !== undefined && number !== "") {
        payload[apiKey] = { number: String(number).trim() };
      }
    });
  }

  return payload;
};

export const buildOrgContactsPayload = (organizationDetails) => {
  const { countryCode, phoneNumber } =
    organizationDetails.organizationContactDetails.contactNumber;
  const fullNumber = `${countryCode || ""}${phoneNumber || ""}`.trim();
  const email = organizationDetails.organizationemail.email_id || "";

  if (!fullNumber && !email) return [];

  return [
    {
      contactNumber: fullNumber,
      email,
      isPrimary: true,
    },
  ];
};

export const normalizeBillingEmail = (email) =>
  String(email || "")
    .trim()
    .toLowerCase();

export const buildBillingPayload = (
  billingDetails = {},
  contactDetails = null,
  options = {},
) => {
  const addressDetails = billingDetails.AddressDetails || {};
  const payload = {};
  const { savedBillingContactEmail } = options;

  if (billingDetails.organizationName !== undefined) {
    payload.organizationName = billingDetails.organizationName;
  }

  if (
    billingDetails.organizationName !== undefined ||
    Object.keys(addressDetails).length > 0
  ) {
    payload.address = {
      pinCode: addressDetails.Pincode || "",
      city: addressDetails.city || "",
      state: addressDetails.state || "",
      country: addressDetails.Country || "",
    };
  }

  if (contactDetails) {
    const { countryCode, phoneNumber } = contactDetails.contactNumber || {};
    const draftEmail = contactDetails.emailId || "";
    let billingContactEmail = draftEmail;

    if (savedBillingContactEmail !== undefined) {
      const normalizedDraft = normalizeBillingEmail(draftEmail);
      const normalizedSaved = normalizeBillingEmail(savedBillingContactEmail);
      billingContactEmail =
        normalizedDraft === normalizedSaved
          ? draftEmail
          : savedBillingContactEmail;
    }

    payload.contactPersonName = contactDetails.contactPersonName || "";
    payload.countryCode = countryCode || "";
    payload.contactNumber = phoneNumber || "";
    payload.email = billingContactEmail;
    payload.billingContact = {
      contactPersonName: contactDetails.contactPersonName || "",
      contactNumber: phoneNumber || "",
      email: billingContactEmail,
    };
  }

  return payload;
};

export const isBillingEmailChangeRejected = (
  draftEmail,
  savedBillingContactEmail,
) =>
  normalizeBillingEmail(draftEmail) !==
  normalizeBillingEmail(savedBillingContactEmail);

export const appendProfileFiles = (formData, files = {}) => {
  if (files.profileImageFile) {
    formData.append("profileImageFile", files.profileImageFile);
  }
  if (files.bannerImageFile) {
    formData.append("bannerImageFile", files.bannerImageFile);
  }
  if (files.passportOrGovtIdFile) {
    formData.append("passportOrGovtIdFile", files.passportOrGovtIdFile);
  }
};

export const appendRegDocumentFiles = (formData, uploadDocuments = {}) => {
  const fileFieldMap = {
    CIN: "cinFile",
    VAT: "vatFile",
    PAN: "panFile",
    DUNS: "dunsFile",
  };

  Object.entries(fileFieldMap).forEach(([uiKey, fieldName]) => {
    const file = uploadDocuments[uiKey]?.file;
    if (file) {
      formData.append(fieldName, file);
    }
  });
};

export const emptyRegDocState = () => ({
  CIN: { number: "", file: null, filePath: "" },
  VAT: { number: "", file: null, filePath: "" },
  PAN: { number: "", file: null, filePath: "" },
  DUNS: { number: "", file: null, filePath: "" },
});

export const regDocsFromProfile = (organization = {}) => ({
  CIN: {
    number: organization.cin?.number || "",
    file: null,
    filePath: organization.cin?.filePath || "",
  },
  VAT: {
    number: organization.vat?.number || "",
    file: null,
    filePath: organization.vat?.filePath || "",
  },
  PAN: {
    number: organization.pan?.number || "",
    file: null,
    filePath: organization.pan?.filePath || "",
  },
  DUNS: {
    number: organization.duns?.number || "",
    file: null,
    filePath: organization.duns?.filePath || "",
  },
});
